const ACTIVE_TAB_CLASS = 'vsd-product-tabs__tab--active'

const initProductTabs = () => {
  const tabContainers = document.querySelectorAll('.vjs-product-tabs')

  tabContainers.forEach((tabContainer) => {
    const tabs = tabContainer.querySelectorAll('.vjs-product-tab')
    const section = tabContainer.closest('section')
    const panels = section.querySelectorAll('.vjs-product-tab-panel')

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const targetId = tab.getAttribute('data-tab-target')
        const targetPanel = document.getElementById(targetId)

        if (!targetPanel) return

        tabs.forEach((t) => {
          t.classList.remove(ACTIVE_TAB_CLASS)
          t.setAttribute('aria-selected', 'false')
        })

        panels.forEach((p) => {
          p.classList.add('hidden')
        })

        tab.classList.add(ACTIVE_TAB_CLASS)
        tab.setAttribute('aria-selected', 'true')
        targetPanel.classList.remove('hidden')
      })
    })
  })
}

export default initProductTabs
